/* Kinetic Society theme behaviour: menu, product form, collection filters, directory search, price calculator, copy buttons. */
(function () {
  'use strict';

  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var money = function (cents, format) {
    var n = cents / 100;
    var s = n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
    return (format || '${{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s).replace(/^\$\s+/, '$');
  };
  var dollars = function (n) { return '$' + n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }); };

  /* mobile menu */
  $$('[data-menu-btn]').forEach(function (b) {
    var nav = document.getElementById(b.getAttribute('aria-controls'));
    if (!nav) return;
    b.addEventListener('click', function () {
      var open = nav.hidden;
      nav.hidden = !open;
      b.setAttribute('aria-expanded', String(open));
    });
  });

  /* product form: option buttons -> variant, price, availability, fit line, image */
  $$('[data-product-form]').forEach(function (root) {
    var data;
    try { data = JSON.parse(root.querySelector('[data-product-json]').textContent); } catch (e) { return; }
    var sizes = {};
    try { sizes = JSON.parse(root.querySelector('[data-size-json]').textContent); } catch (e) {}
    var form = root.querySelector('form[action*="/cart/add"]');
    var idInput = form && form.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var addBtn = root.querySelector('[data-add]');
    var fit = root.querySelector('[data-fit]');
    var mainImg = document.querySelector('[data-main-image]');
    var selected = (data.current || data.variants[0]).options.slice();

    function findVariant() {
      return data.variants.filter(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); })[0];
    }
    function update() {
      var v = findVariant();
      if (idInput) idInput.value = v ? v.id : '';
      if (priceEl) priceEl.textContent = v ? money(v.price, data.money_format) : '';
      if (compareEl) {
        var c = v && v.compare_at_price > v.price;
        compareEl.hidden = !c;
        if (c) compareEl.textContent = money(v.compare_at_price, data.money_format);
      }
      if (addBtn) {
        var ok = v && v.available;
        addBtn.disabled = !ok;
        addBtn.textContent = !v ? addBtn.dataset.unavailable : ok ? addBtn.dataset.add : addBtn.dataset.soldout;
      }
      if (fit && data.size_index > -1 && sizes) {
        var row = (sizes.rows || []).filter(function (r) { return r[0] === selected[data.size_index]; })[0];
        fit.textContent = row ? selected[data.size_index] + ': ' + row[1] + ' cm half chest (' + (row[1] / 2.54).toFixed(1) + ' in), ' + row[2] + ' cm long (' + (row[2] / 2.54).toFixed(1) + ' in). True to size.' : '';
      }
      if (v && v.featured_image && mainImg) mainImg.src = v.featured_image;
      if (v && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    $$('[data-option-index]', root).forEach(function (group) {
      var idx = Number(group.dataset.optionIndex);
      group.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        selected[idx] = b.dataset.value;
        $$('button', group).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        update();
      });
    });
    $$('[data-qty]', root).forEach(function (q) {
      var input = q.querySelector('input');
      q.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        var n = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.dataset.step));
        input.value = n;
      });
    });
    update();
  });

  /* product thumbnails */
  $$('[data-thumbs]').forEach(function (box) {
    var main = document.querySelector('[data-main-image]');
    box.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || !main) return;
      main.src = b.dataset.src;
      main.alt = b.dataset.alt || main.alt;
      $$('button', box).forEach(function (x) { x.setAttribute('aria-current', String(x === b)); });
    });
  });

  /* collection: load the remaining pages so filters cover the whole collection */
  var loadMore = function (grid) {
    var urls = (grid.dataset.more || '').split(' ').filter(Boolean);
    if (!urls.length) return Promise.resolve();
    return Promise.all(urls.map(function (u) {
      var url = new URL(u, window.location.origin);
      url.searchParams.set('section_id', grid.dataset.section);
      return fetch(url.toString()).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (pages) {
      var added = 0;
      pages.forEach(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var other = doc.getElementById(grid.id);
        if (!other) return;
        $$('.card', other).forEach(function (c) { grid.appendChild(c); added++; });
      });
      if (added) $$('[data-pagination]').forEach(function (n) { n.hidden = true; });
    });
  };

  /* collection: sport chips */
  $$('[data-sport-filter]').forEach(function (bar) {
    var grid = document.getElementById(bar.dataset.target);
    var line = document.querySelector('[data-count-line]');
    if (!grid) return;
    var current = 'all';
    function run(sport) {
      current = sport;
      var cards = $$('[data-sport]', grid), shown = 0;
      cards.forEach(function (c) { var ok = sport === 'all' || c.dataset.sport === sport; c.hidden = !ok; if (ok) shown++; });
      if (line) line.textContent = shown + (shown === 1 ? ' jersey' : ' jerseys');
    }
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      $$('button', bar).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      run(b.dataset.sport);
    });
    run('all');
    loadMore(grid).then(function () { run(current); });
  });

  /* collection: sort select navigates with sort_by */
  $$('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* directory search */
  $$('[data-directory-search]').forEach(function (input) {
    var scope = document.getElementById(input.dataset.target);
    if (!scope) return;
    var cards = $$('[data-name]', scope);
    var line = document.querySelector('[data-directory-count]');
    var empty = document.querySelector('[data-directory-empty]');
    function run() {
      var t = input.value.trim().toLowerCase(), shown = 0;
      cards.forEach(function (c) { var ok = !t || c.dataset.name.indexOf(t) > -1; c.hidden = !ok; if (ok) shown++; });
      $$('[data-group]', scope).forEach(function (g) { g.hidden = !$$('[data-name]', g).some(function (c) { return !c.hidden; }); });
      if (line) line.textContent = shown + (shown === 1 ? ' organization' : ' organizations');
      if (empty) empty.hidden = shown > 0;
    }
    input.addEventListener('input', run);
    run();
  });

  /* group price calculator: reads tiers from data attributes */
  $$('[data-calc]').forEach(function (calc) {
    var tables;
    try { tables = JSON.parse(calc.querySelector('[data-calc-json]').textContent); } catch (e) { return; }
    var type = Object.keys(tables)[0], sport = 0;
    var qty = calc.querySelector('[data-calc-qty]'), each = calc.querySelector('[data-calc-each]'), total = calc.querySelector('[data-calc-total]'), note = calc.querySelector('[data-calc-note]');
    var DEF = note.textContent, dash = '–';
    function update() {
      var t = tables[type], n = Math.floor(Number(qty.value));
      if (!t || !t.tiers.length) return;
      if (!n || n < 1) { each.textContent = dash; total.textContent = dash; note.textContent = 'Enter how many jerseys you need.'; return; }
      if (n < t.tiers[0].min) { each.textContent = dash; total.textContent = dash; note.textContent = 'Minimum order is ' + t.tiers[0].min + ' jerseys.'; return; }
      if (t.cap && n >= t.cap) { each.textContent = 'Ask us'; total.textContent = 'Ask us'; note.textContent = 'Orders of ' + t.cap + ' or more get custom pricing. Submit a project and we will quote it.'; return; }
      var tier = t.tiers.filter(function (r) { return n >= r.min; }).pop();
      var p = tier.prices[sport];
      each.textContent = dollars(p); total.textContent = dollars(p * n); note.textContent = DEF;
    }
    $$('[data-calc-type] button', calc).forEach(function (b) {
      b.addEventListener('click', function () {
        type = b.dataset.value;
        $$('[data-calc-type] button', calc).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        update();
      });
    });
    $$('[data-calc-sport] button', calc).forEach(function (b) {
      b.addEventListener('click', function () {
        sport = Number(b.dataset.value);
        $$('[data-calc-sport] button', calc).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        update();
      });
    });
    qty.addEventListener('input', update);
    calc.addEventListener('submit', function (e) { e.preventDefault(); });
    update();
  });

  /* copy buttons */
  $$('[data-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var t = document.getElementById(b.dataset.copy);
      if (!t) return;
      var done = function () { var o = b.textContent; b.textContent = b.dataset.done || 'Copied'; setTimeout(function () { b.textContent = o; }, 1800); };
      var select = function () { var r = document.createRange(); r.selectNodeContents(t); var s = window.getSelection(); s.removeAllRanges(); s.addRange(r); };
      if (navigator.clipboard) navigator.clipboard.writeText(t.textContent.trim()).then(done, select); else select();
    });
  });

  /* cart quantity steppers submit the update */
  $$('[data-cart-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    q.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      input.value = Math.max(0, (parseInt(input.value, 10) || 0) + Number(b.dataset.step));
      input.form.submit();
    });
  });

  /* size finder: sport tabs, cm/in switch, closest size to a measured half chest */
  $$('[data-size-guide]').forEach(function (root) {
    var unit = 'in', sport = 0;
    var input = root.querySelector('[data-sg-input]'), result = root.querySelector('[data-sg-result]');
    var hint = result ? result.textContent : '';
    function chart() { return root.querySelector('[data-sg-chart="' + sport + '"]'); }
    function render() {
      $$('[data-sg-chart]', root).forEach(function (c) { c.hidden = c.dataset.sgChart !== String(sport); });
      $$('[data-cm]', root).forEach(function (el) { el.textContent = unit === 'cm' ? el.dataset.cm : el.dataset.in; });
      $$('[data-u]', root).forEach(function (el) { el.textContent = unit; });
      $$('[data-sg-unit-label]', root).forEach(function (el) { el.textContent = unit; });
      if (input) input.placeholder = unit === 'cm' ? 'e.g. 54' : 'e.g. 21';
      var rows = $$('tr[data-chest]', chart());
      rows.forEach(function (r) { r.classList.remove('is-match'); });
      var v = parseFloat(input && input.value);
      if (!v || v <= 0) { if (result) result.textContent = hint; return; }
      var cm = unit === 'cm' ? v : v * 2.54, best = null, diff = Infinity;
      rows.forEach(function (r) { var d = Math.abs(Number(r.dataset.chest) - cm); if (d < diff) { diff = d; best = r; } });
      if (!best) return;
      best.classList.add('is-match');
      var shown = unit === 'cm' ? best.dataset.chest : (Number(best.dataset.chest) / 2.54).toFixed(1);
      result.innerHTML = '<b>' + best.dataset.size + '</b> is your closest size (' + shown + ' ' + unit + ' half chest).';
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      var group = b.closest('[data-sg-sport], [data-sg-units]'); if (!group) return;
      $$('button', group).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      if (group.hasAttribute('data-sg-sport')) sport = Number(b.dataset.value);
      else { var prev = unit; unit = b.dataset.value; if (input && input.value && prev !== unit) { var n = parseFloat(input.value); input.value = (unit === 'cm' ? n * 2.54 : n / 2.54).toFixed(1); } }
      render();
    });
    if (input) input.addEventListener('input', render);
    render();
  });

  /* review wall: show more + search */
  $$('[data-reviews-wall]').forEach(function (root) {
    var step = Number(root.dataset.step) || 36, limit = step;
    var cards = $$('.quote', root.querySelector('[data-rw-grid]'));
    var q = root.querySelector('[data-rw-search]'), more = root.querySelector('[data-rw-more]');
    var line = root.querySelector('[data-rw-count]'), empty = root.querySelector('[data-rw-empty]');
    function run() {
      var t = q ? q.value.trim().toLowerCase() : '', matches = 0;
      cards.forEach(function (c) {
        var ok = !t || c.textContent.toLowerCase().indexOf(t) > -1;
        if (ok) matches++;
        c.hidden = !ok || matches > limit;
      });
      if (more) more.parentNode.hidden = matches <= limit;
      if (line) line.textContent = t ? matches + (matches === 1 ? ' review mentions "' : ' reviews mention "') + q.value.trim() + '"' : cards.length + ' five-star reviews';
      if (empty) empty.hidden = matches > 0;
    }
    if (more) more.addEventListener('click', function () { limit += step; run(); });
    if (q) q.addEventListener('input', function () { limit = step; run(); });
    run();
  });

  /* product recommendations */
  $$('[data-recommendations]').forEach(function (box) {
    fetch(box.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var inner = doc.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim()) { box.innerHTML = inner.innerHTML; box.hidden = false; }
    }).catch(function () {});
  });
})();
